import { jsxs as o, jsx as s } from "react/jsx-runtime";
import '../../assets/IconClose.css';const C = "_icon_1pz17_1", r = "_circle_1pz17_11", e = "_cross_1pz17_19", c = {
  icon: C,
  circle: r,
  cross: e
}, i = () => /* @__PURE__ */ o("svg", { viewBox: "0 0 30.249 29.8975", className: c.icon, children: [
  /* @__PURE__ */ s(
    "path",
    {
      className: c.circle,
      d: "M14.9414 29.8828C23.1885 29.8828 29.8828 23.1738 29.8828 14.9414C29.8828 6.69434 23.1885 0 14.9414 0C6.70898 0 0 6.69434 0 14.9414C0 23.1738 6.70898 29.8828 14.9414 29.8828Z"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      className: c.cross,
      d: "M10.0195 21.0938C9.3457 21.0938 8.81836 20.5518 8.81836 19.8779C8.81836 19.5557 8.93555 19.248 9.16992 19.0283L13.2275 14.9561L9.16992 10.8984C8.93555 10.6641 8.81836 10.3711 8.81836 10.0488C8.81836 9.36035 9.3457 8.84766 10.0195 8.84766C10.3564 8.84766 10.6201 8.96484 10.8545 9.18457L14.9414 13.2568L19.0576 9.16992C19.3066 8.9209 19.5703 8.81836 19.8926 8.81836C20.5664 8.81836 21.1084 9.3457 21.1084 10.0195C21.1084 10.3564 21.0059 10.6201 20.7422 10.8838L16.6699 14.9561L20.7275 19.0137C20.9766 19.2334 21.0938 19.541 21.0938 19.8779C21.0938 20.5518 20.5518 21.0938 19.8633 21.0938C19.5264 21.0938 19.2188 20.9766 18.999 20.7422L14.9414 16.6699L10.8984 20.7422C10.6641 20.9766 10.3564 21.0938 10.0195 21.0938Z"
    }
  )
] });
export {
  i as IconClose
};
